import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Transfer20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_959)'>
      <path
        d='M16.1895 4.75001L2.00012 4.75001L2.00012 6.25001L16.1895 6.25001L13.4698 8.96968L14.5305 10.0303L19.0608 5.50001L14.5305 0.969681L13.4698 2.03034L16.1895 4.75001Z'
        fill='currentColor'
      />
      <path
        d='M3.81077 13.75L6.53044 11.0303L5.46978 9.96967L0.939453 14.5L5.46978 19.0303L6.53044 17.9697L3.81078 15.25H18.0001V13.75H3.81077Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_959'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Transfer20.displayName = 'Transfer20';
export default Transfer20;
